(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el, opt) {
      this.el = el;
      if ($("." + this.el).length > 0) {
        this.event();
      } else if ($(".js-case-refs-slider").length > 0) {
        this.initCaseRefsSlider();
      }
    }
    event() {
      // 理由タブ: 「相続させる側 (親世代)も見る」ボタンでタブ2を表示
      $(".js-reason-tab-switch").on("click", function () {
        const index = $(this).data("tab-index");
        $(".p-top__reason-tab-btn").eq(index).trigger("click");
      });
  
      this.initCaseSlider();
      this.initCaseRefsSlider();
      this.initCaseListSlider();
      this.initSeminarSlider();
      this.initReasonMangaScroll();
    }
  
    /**
     * 漫画エリア: 「タテ読み」ヒント非表示／カスタムスクロールバー。
     * トラックの黄塗りは scrollTop/maxScroll を --scroll-progress（0〜1）で反映。
     * x-teleport 後に DOM に現れるため MutationObserver と alpine:initialized で再バインド。
     */
    initReasonMangaScroll() {
      const bound = new WeakSet();
  
      const bindOne = (scrollEl) => {
        if (bound.has(scrollEl)) {
          return;
        }
  
        const $scrollbar = $(scrollEl).next(".p-top__reason-manga-scrollbar");
        const $track = $scrollbar.find(".p-top__reason-manga-scrollbar-track");
        const $thumb = $scrollbar.find(".p-top__reason-manga-scrollbar-thumb");
        const trackEl = $track[0];
        const thumbEl = $thumb[0];
        const viewportEl = $(scrollEl).closest(
          ".p-top__reason-manga-viewport",
        )[0];
  
        if (!$scrollbar.length || !trackEl || !thumbEl || !viewportEl) {
          return;
        }
  
        bound.add(scrollEl);
  
        const MIN_THUMB = 20;
  
        function updateThumb() {
          const trackH = trackEl.clientHeight;
          const { scrollTop, scrollHeight, clientHeight } = scrollEl;
  
          if (scrollHeight <= clientHeight + 1 || trackH < 1) {
            $scrollbar.css("visibility", "hidden");
            trackEl.style.setProperty("--scroll-progress", "0");
            thumbEl.style.height = "0";
            thumbEl.style.top = "0";
            return;
          }
  
          $scrollbar.css("visibility", "visible");
          const thumbH = Math.max(
            (clientHeight / scrollHeight) * trackH,
            MIN_THUMB,
          );
          const maxScroll = scrollHeight - clientHeight;
          const maxThumbTop = trackH - thumbH;
          const thumbTop =
            maxScroll > 0 ? (scrollTop / maxScroll) * maxThumbTop : 0;
          const scrollProgress = maxScroll > 0 ? scrollTop / maxScroll : 0;
  
          trackEl.style.setProperty("--scroll-progress", String(scrollProgress));
          thumbEl.style.height = `${thumbH}px`;
          thumbEl.style.top = `${thumbTop}px`;
        }
  
        $(scrollEl).on("scroll.reasonMangaSb", function () {
          if (this.scrollTop > 12) {
            $(this)
              .closest(".p-top__reason-manga-viewport")
              .addClass("is-scrolled");
          }
          updateThumb();
        });
  
        $(scrollEl)
          .find("img")
          .on("load.reasonMangaSb", function () {
            updateThumb();
          });
  
        if (typeof ResizeObserver !== "undefined") {
          const ro = new ResizeObserver(() => {
            updateThumb();
          });
          ro.observe(scrollEl);
          ro.observe(trackEl);
        }
  
        $(window).on("resize.reasonMangaSb", function () {
          updateThumb();
        });
  
        let dragStartY = 0;
        let dragStartScrollTop = 0;
  
        $thumb.on("pointerdown.reasonMangaSb", function (e) {
          e.preventDefault();
          dragStartY = e.clientY;
          dragStartScrollTop = scrollEl.scrollTop;
          thumbEl.setPointerCapture(e.pointerId);
  
          function onDrag(ev) {
            const trackH = trackEl.clientHeight;
            const { scrollHeight, clientHeight } = scrollEl;
            const thumbH = thumbEl.offsetHeight;
            const maxScroll = scrollHeight - clientHeight;
            const maxThumbTop = Math.max(trackH - thumbH, 0);
            if (maxScroll <= 0 || maxThumbTop <= 0) {
              return;
            }
            const deltaY = ev.clientY - dragStartY;
            scrollEl.scrollTop =
              dragStartScrollTop + (deltaY / maxThumbTop) * maxScroll;
          }
  
          function endDrag(ev) {
            try {
              thumbEl.releasePointerCapture(ev.pointerId);
            } catch (err) {
              /* noop */
            }
            $(thumbEl).off(
              "pointermove.reasonMangaSb pointerup.reasonMangaSb pointercancel.reasonMangaSb",
            );
          }
  
          $(thumbEl).on("pointermove.reasonMangaSb", onDrag);
          $(thumbEl).on(
            "pointerup.reasonMangaSb pointercancel.reasonMangaSb",
            endDrag,
          );
        });
  
        requestAnimationFrame(updateThumb);
      };
  
      const tryBindAll = () => {
        document
          .querySelectorAll(".js-reason-manga-scroll")
          .forEach((el) => bindOne(el));
      };
  
      tryBindAll();
  
      if (typeof MutationObserver !== "undefined") {
        const mo = new MutationObserver(() => {
          tryBindAll();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
  
      document.addEventListener("alpine:initialized", tryBindAll);
    }
  
    /**
     * 解決事例: PCは4件以上、SPは2件以上のときだけ Swiper。
     */
    initCaseSlider() {
      const $sliderEl = $(".p_top .js-case-slider");
      if (!$sliderEl.length || !$sliderEl.find(".swiper-slide").length) {
        return;
      }
  
      const sliderEl = $sliderEl[0];
      const $wrapper = $sliderEl.find(".swiper-wrapper");
      const $originalSlides = $wrapper.children(".swiper-slide").clone(true, true);
      const mq = window.matchMedia("(max-width: 767px)");
      let caseSwiper = null;
  
      const getActiveFilter = () => {
        return $(".js-case-filter-btn.is-active").data("case-filter") || "all";
      };
  
      const matchesFilter = (slide, filter) => {
        if (filter === "all") {
          return true;
        }
  
        const caseCats = String($(slide).data("case-cat") || "").split(/\s+/);
        return caseCats.includes(filter);
      };
  
      const destroyCaseSwiper = () => {
        if (caseSwiper) {
          caseSwiper.destroy(true, true);
          caseSwiper = null;
        }
      };
  
      const apply = () => {
        const filter = getActiveFilter();
        const $filteredSlides = $originalSlides
          .filter(function () {
            return matchesFilter(this, filter);
          })
          .clone(true, true);
        const slideCount = $filteredSlides.length;
        const shouldUseSwiper = mq.matches ? slideCount >= 2 : slideCount >= 4;
        const gridColumns = mq.matches ? 1 : Math.max(Math.min(slideCount, 3), 1);
  
        destroyCaseSwiper();
        $wrapper.empty().append($filteredSlides);
        sliderEl.style.setProperty("--case-grid-columns", gridColumns);
  
        if (!shouldUseSwiper || typeof Swiper === "undefined") {
          $sliderEl.removeClass("is-slider").addClass("is-grid");
          return;
        }
  
        $sliderEl.removeClass("is-grid").addClass("is-slider");
  
        caseSwiper = new Swiper(sliderEl, {
          slidesPerView: "auto",
          spaceBetween: 20,
          centeredSlides: true,
          watchOverflow: true,
          loop: true,
          simulateTouch: true,
          grabCursor: true,
          pagination: {
            el: $sliderEl.find(".swiper-pagination")[0],
            clickable: true,
          },
          navigation: {
            nextEl: $sliderEl.find(".swiper-button-next")[0],
            prevEl: $sliderEl.find(".swiper-button-prev")[0],
          },
          breakpoints: {
            768: {
              spaceBetween: 40,
            },
          },
        });
      };
  
      $(".js-case-filter-btn").on("click", function () {
        $(".js-case-filter-btn")
          .removeClass("is-active")
          .attr("aria-selected", "false");
        $(this).addClass("is-active").attr("aria-selected", "true");
  
        apply();
      });
  
      apply();
  
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", apply);
      } else if (typeof mq.addListener === "function") {
        mq.addListener(apply);
      }
    }
  
    /**
     * 事例詳細: 参考画像が4枚以上のときの Swiper。
     */
    initCaseRefsSlider() {
      const $sliderEls = $(".js-case-refs-slider");
      if (!$sliderEls.length || typeof Swiper === "undefined") {
        return;
      }
  
      $sliderEls.each(function () {
        const sliderEl = this;
        const $sliderEl = $(sliderEl);
        const refsCount = Number($sliderEl.data("refs-count")) || 0;
  
        if (sliderEl.swiper || refsCount < 4) {
          return;
        }
  
        new Swiper(sliderEl, {
          slidesPerView: "auto",
          spaceBetween: 12,
          watchOverflow: true,
          loop: true,
          simulateTouch: true,
          grabCursor: true,
          pagination: {
            el: $sliderEl.find(".swiper-pagination")[0],
            clickable: true,
          },
          navigation: {
            nextEl: $sliderEl.find(".swiper-button-next")[0],
            prevEl: $sliderEl.find(".swiper-button-prev")[0],
          },
          breakpoints: {
            768: {
              spaceBetween: 16,
            },
          },
        });
      });
    }
  
    /**
     * 事例カード一覧: SPのみ Swiper。PCは CSS グリッド（_top.scss）で静的3列。
     */
    initCaseListSlider() {
      const $sliderEl = $(".p_top .js-case-list-slider");
      if (!$sliderEl.length || typeof Swiper === "undefined") {
        return;
      }
  
      const sliderEl = $sliderEl[0];
      let caseListSwiper = null;
      const mq = window.matchMedia("(max-width: 767px)");
  
      const apply = () => {
        if (mq.matches) {
          if (caseListSwiper) {
            return;
          }
          caseListSwiper = new Swiper(sliderEl, {
            slidesPerView: "auto",
            spaceBetween: 16,
            centeredSlides: true,
            watchOverflow: true,
            loop: true,
            pagination: {
              el: $sliderEl.find(".swiper-pagination")[0],
              clickable: true,
            },
            navigation: {
              nextEl: $sliderEl.find(".swiper-button-next")[0],
              prevEl: $sliderEl.find(".swiper-button-prev")[0],
            },
          });
        } else if (caseListSwiper) {
          caseListSwiper.destroy(true, true);
          caseListSwiper = null;
        }
      };
  
      apply();
  
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", apply);
      } else if (typeof mq.addListener === "function") {
        mq.addListener(apply);
      }
    }
  
    /**
     * セミナー: SPのみ Swiper。PCは CSS グリッド（_top.scss）で静的3列。
     */
    initSeminarSlider() {
      const $sliderEl = $(".p_top .js-seminar-slider");
      if (!$sliderEl.length || typeof Swiper === "undefined") {
        return;
      }
  
      const sliderEl = $sliderEl[0];
      let seminarSwiper = null;
      const mq = window.matchMedia("(max-width: 767px)");
  
      const apply = () => {
        if (mq.matches) {
          if (seminarSwiper) {
            return;
          }
          seminarSwiper = new Swiper(sliderEl, {
            slidesPerView: "auto",
            spaceBetween: 16,
            centeredSlides: true,
            watchOverflow: true,
            loop: true,
            pagination: {
              el: $sliderEl.find(".swiper-pagination")[0],
              clickable: true,
            },
            navigation: {
              nextEl: $sliderEl.find(".swiper-button-next")[0],
              prevEl: $sliderEl.find(".swiper-button-prev")[0],
            },
          });
        } else if (seminarSwiper) {
          seminarSwiper.destroy(true, true);
          seminarSwiper = null;
        }
      };
  
      apply();
  
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", apply);
      } else if (typeof mq.addListener === "function") {
        mq.addListener(apply);
      }
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    const addPolicyLink = (wrap) => {
    if (!wrap) return;
  
    const url = wrap.dataset.url;
    if (!url) return;
  
    // すでにリンク化済みなら何もしない
    if (wrap.querySelector('a[data-acceptance-link="privacy"]')) return;
  
    // 文言が入っている要素（CF7のラベルテキスト）
    const labelEl = wrap.querySelector(".wpcf7-list-item-label");
    if (!labelEl) return;
  
    const text = labelEl.textContent ?? "";
    const keyword = "プライバシーポリシー";
  
    // キーワードが無いなら何もしない
    if (!text.includes(keyword)) return;
  
    // 既存の内容を安全に組み直す（文字列置換でHTMLを壊しにくくする）
    const before = text.split(keyword)[0];
    const after = text.split(keyword).slice(1).join(keyword);
  
    // 中身を作り直す
    labelEl.textContent = ""; // いったん空に
  
    labelEl.append(document.createTextNode(before));
  
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.dataset.acceptanceLink = "privacy";
    a.textContent = keyword;
    labelEl.append(a);
  
    labelEl.append(document.createTextNode(after));
  };
  
    (() => {
    const HEADER_OFFSET = 80; // 必要に応じて調整
  
    function stopSmoothScroll() {
      document.documentElement.classList.add("is-no-smooth");
  
      if (window.lenis && typeof window.lenis.stop === "function")
        window.lenis.stop();
      if (window.locoScroll && typeof window.locoScroll.stop === "function")
        window.locoScroll.stop();
    }
  
    function startSmoothScroll() {
      document.documentElement.classList.remove("is-no-smooth");
  
      if (window.lenis && typeof window.lenis.start === "function")
        window.lenis.start();
      if (window.locoScroll && typeof window.locoScroll.start === "function")
        window.locoScroll.start();
    }
  
    function raf2(cb) {
      requestAnimationFrame(() => requestAnimationFrame(cb));
    }
  
    function waitForLoad(cb) {
      if (document.readyState === "complete") return cb();
      window.addEventListener("load", cb, { once: true });
    }
  
    function waitForFonts(cb) {
      const fonts = document.fonts;
      if (!fonts || !fonts.ready || typeof fonts.ready.then !== "function")
        return cb();
      fonts.ready.then(cb).catch(cb);
    }
  
    function scrollToHash(hash) {
      const id = (hash || "").replace("#", "");
      if (!id) return;
  
      const target = document.getElementById(id);
      if (!target) return;
  
      const y =
        target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo(0, Math.max(0, y));
    }
  
    function handleInitialHashScroll() {
      if (!location.hash) return;
  
      const hash = location.hash;
  
      // ① 先に hash を消してブラウザの自動スクロールを抑止
      history.replaceState(null, "", location.pathname + location.search);
  
      // ② smooth 停止
      stopSmoothScroll();
  
      // ③ load → fonts → 2raf の順で待つ
      waitForLoad(() => {
        waitForFonts(() => {
          raf2(() => {
            // ④ 位置を確定してスクロール
            scrollToHash(hash);
  
            // ⑤ hash を戻す（共有・戻る対策）
            history.replaceState(
              null,
              "",
              location.pathname + location.search + hash,
            );
  
            // ⑥ smooth 復帰
            startSmoothScroll();
          });
        });
      });
    }
  
    handleInitialHashScroll();
  })();
  
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    /**
   * フッターがビューポートに入ったら追従CTAをフェードアウト、外れたらフェードイン
   */
  const floatingCtaFooterFade = () => {
    const cta = document.querySelector(".c-floating-cta");
    if (!cta) return;
  
    const footer = cta.closest("footer.l-footer");
    if (!footer) return;
  
    if (!("IntersectionObserver" in window)) return;
  
    const links = cta.querySelectorAll("a");
  
    const setHidden = (hidden) => {
      cta.classList.toggle("c-floating-cta--footer-inview", hidden);
      links.forEach((a) => {
        if (hidden) {
          a.setAttribute("tabindex", "-1");
        } else {
          a.removeAttribute("tabindex");
        }
      });
      if (hidden) {
        cta.setAttribute("aria-hidden", "true");
      } else {
        cta.removeAttribute("aria-hidden");
      }
    };
  
    const observer = new IntersectionObserver(
      ([entry]) => {
        setHidden(entry.isIntersecting);
      },
      { threshold: 0, rootMargin: "0px" }
    );
  
    observer.observe(footer);
  };
  
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    class HeaderDrawer {
    constructor(el, opt) {
      this.el = el;
      this.$root = $("." + this.el);
      if (this.$root.length > 0) {
        this.bind();
      }
    }
  
    bind() {
      const $html = $("html");
      const $trigger = $(".js-header-drawer-trigger");
      const $close = $(".js-header-drawer-close");
      const $drawer = $("#header-drawer");
  
      const isOpen = () => $html.hasClass("is-header-drawer-open");
  
      const open = () => {
        if (isOpen()) return;
        $html.addClass("is-header-drawer-open");
        $trigger.attr({
          "aria-expanded": "true",
          "aria-label": "閉じる",
        });
        $drawer.attr("aria-hidden", "false");
        if (!$html.hasClass("is-hidden")) {
          scrollBan();
        }
      };
  
      const close = () => {
        if (!isOpen()) return;
        $html.removeClass("is-header-drawer-open");
        $trigger.attr({
          "aria-expanded": "false",
          "aria-label": "メニュー",
        });
        $drawer.attr("aria-hidden", "true");
        if ($html.hasClass("is-hidden")) {
          scrollBan();
        }
      };
  
      $trigger.on("click", function () {
        if (isOpen()) {
          close();
        } else {
          open();
        }
      });
  
      $close.on("click", function () {
        close();
      });
  
      $drawer.on("click", "a", function () {
        close();
      });
  
      $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
          close();
        }
      });
    }
  }
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      this.eachItemLast = this.el + '-eachItem-last';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      const deferredInviewItems = [];
      inviewItem.forEach((e)=>{
        if (e.classList.contains('js-inview-on-loading')) {
          deferredInviewItems.push(e);
          return;
        }
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
      if (deferredInviewItems.length > 0) {
        $(window).one('loadingComplete', () => {
          deferredInviewItems.forEach((e) => {
            observerEnter.observe(e);
          });
        });
      }
    }
    inviewEachUp(item){
      const eachItemElements = $(item).find(this.eachItem);
      const baseDelay = 0.2 * eachItemElements.length;
  
      eachItemElements.each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemLast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: baseDelay + (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    const mobileFixedButton = (el) => {
    ScrollTrigger.create({
      trigger: "body",
      start: "+=300",
      end: "-=310",
      onEnter: () => {
        el.classList.add("is-active");
      },
      onLeaveBack: () => {
        el.classList.remove("is-active");
      },
    });
    ScrollTrigger.create({
      trigger: "#form",
      start: "top bottom",
      end: "top bottom",
      onEnter: () => {
        el.classList.remove("is-active");
      },
      onLeaveBack: () => {
        el.classList.add("is-active");
      },
    });
  };
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClase();
      })
    }
  }
    document.addEventListener("DOMContentLoaded", () => {
    // 戻るボタンのセレクタは環境に合わせて増やしてOK
    const backBtns = document.querySelectorAll(".wpcf7-previous");
  
    if (!backBtns.length) return;
  
    backBtns.forEach((backBtn) => {
      backBtn.style.removeProperty("display");
  
      backBtn.addEventListener("click", (e) => {
        e.preventDefault();
  
        // まずはリファラ（元ページ）を優先
        let to = document.referrer;
  
        // referrerが取れない/外部/空の場合の保険（必要なら任意のURLに変更）
        if (!to) {
          to = "/"; // 例：トップへ
        }
  
        // 既に#が付いてても付け替える
        to = to.split("#")[0] + "#form";
  
        window.location.href = to;
      });
    });
  });
  
    // -------------------------------------------------
  // スクロール禁止
  // -------------------------------------------------
  let scrollTop = 0;
  
  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
  
  function scrollBan() {
    const html = $("html")[0];
    // スクロール禁止
    if (html.classList.contains("is-hidden")) {
      html.classList.remove("is-hidden");
      html.style.top = "";
      html.style.removeProperty("--scrollbar-compensation");
      window.scrollTo(0, scrollTop);
      $("html").css({ "scroll-behavior": "smooth" });
    } else {
      scrollTop = window.scrollY;
      const scrollbarWidth = getScrollbarWidth();
      html.style.top = scrollTop * -1 + "px";
      if (scrollbarWidth > 0) {
        html.style.setProperty(
          "--scrollbar-compensation",
          scrollbarWidth + "px"
        );
      }
      html.classList.add("is-hidden");
      $("html").css({ "scroll-behavior": "inherit" });
    }
  }
  
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  

  // ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
  window.addEventListener("load", () => {
    setTimeout(() => {
      $(".js-loading").fadeOut();
      $(window).trigger("loadingComplete");
    }, 1500);
  });

  (() => {
    let imgParallax = new ImgParallax("js-parallax");
    let inviewEvent = new InviewEvent("js-inview");

    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top("p-top");

    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let topElementor = new TopElementor("js-topElementor");
    let headerDrawer = new HeaderDrawer("l-header--not-lp");
    let modal = new Modal("js-modal");
    let accordion = new Accordion("js-accordion");
    let editor = new Editor("c-content");
  })();

  const getLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const setContactSeminarDateMin = (contactSeminarEl) => {
    const today = getLocalDateString(new Date());

    contactSeminarEl
      .querySelectorAll('.contact-seminar__datetime-row input[type="date"]')
      .forEach((dateInput) => {
        dateInput.setAttribute("min", today);
      });
  };

  //DOMContentLoaded
  $(() => {
    const contactSeminarEl = document.querySelector(".contact-seminar");
    if (contactSeminarEl) {
      if (typeof contactSeminarChoiceLabel === "function") {
        contactSeminarChoiceLabel(contactSeminarEl);
      }
      setContactSeminarDateMin(contactSeminarEl);
    }
    const policyEl = document.querySelector(".js-acceptance");
    policyEl && addPolicyLink(policyEl);
    const mobileFixed = document.querySelector(".js-fixed-button");
    mobileFixed && mobileFixedButton(mobileFixed);
    floatingCtaFooterFade();
  });

  //images resources loaded
  $(window).on("load", () => {
    $(window).trigger("loading");
  });

  //after loading animation
  $(window).on("loading", () => {});
})(jQuery);
